<template>
    <select-label
        v-model="selectData"
        v-bind="bind"
        :item-text="itemText"
        :item-value="itemValue"
        chips
        multiple
        deletable-chips
    >
        <template v-slot:selection="props">
            <v-chip close @click:close="remove(props.item)">
                <span class="chip-text"> {{ props.item[itemText] }} </span>
            </v-chip>
        </template>
    </select-label>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import SelectLabel from './SelectLabel.vue';
import { shallowCopy } from '../../utils/types/utility';

@Component({
    name: 'SelectLabelDeletableChips',
    components: {
        SelectLabel,
    },
})
export default class SelectLabelDeletableChips extends Vue {
    @Prop({ type: [Array], default: () => [] }) value: Array<string | number>;
    @Prop({ default: 'text' }) readonly itemText: string;
    @Prop({ default: 'value' }) readonly itemValue: string;

    get selectData(): Array<string | number> {
        return this.value;
    }
    set selectData(newValue: Array<string | number>) {
        this.$emit('input', newValue);
    }

    /*
     * 親から受け取ったプロパティをまるごと渡す
     * このコンポーネントで上書きする分は消しておく
     */
    get bind(): Object {
        let bind = shallowCopy(this.$attrs);

        delete bind.value;
        delete bind.chips;
        delete bind.multiple;
        delete bind['deletable-chips'];

        return bind;
    }

    /*
     * methods
     */
    remove(item) {
        const removeValue = item[this.itemValue] as string | number;
        this.selectData = this.selectData.filter(v => v !== removeValue);
    }
}
</script>

<style lang="scss">
.chip-text {
    max-width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>
